import { render } from "./CardEditFormsan.vue?vue&type=template&id=70c5f74a"
import script from "./CardEditFormsan.vue?vue&type=script&lang=js"
export * from "./CardEditFormsan.vue?vue&type=script&lang=js"

import "./CardEditFormsan.vue?vue&type=style&index=0&id=70c5f74a&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__